var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgExport({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.09618 20.5V18.7307L7.98078 17.8461H4.8077C4.30257 17.8461 3.875 17.6711 3.525 17.3211C3.175 16.9711 3 16.5436 3 16.0385V5.3077C3 4.80257 3.175 4.375 3.525 4.025C3.875 3.675 4.30257 3.5 4.8077 3.5H12.7212V4.99998H4.8077C4.73077 4.99998 4.66024 5.03203 4.59613 5.09613C4.53202 5.16024 4.49998 5.23077 4.49998 5.3077V16.0385C4.49998 16.1154 4.53202 16.1859 4.59613 16.25C4.66024 16.3141 4.73077 16.3462 4.8077 16.3462H20.1923C20.2692 16.3462 20.3397 16.3141 20.4038 16.25C20.4679 16.1859 20.5 16.1154 20.5 16.0385V13H22V16.0385C22 16.5436 21.825 16.9711 21.475 17.3211C21.125 17.6711 20.6974 17.8461 20.1923 17.8461H17.0192L17.9038 18.7307V20.5H7.09618Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3558 3.50035L21 8.14456L19.9462 9.19838L17.1058 6.36373V14.6445H15.6058V6.36373L12.7654 9.19838L11.7116 8.14456L16.3558 3.50035Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExport);
export default __webpack_public_path__ + "static/media/export.76f8dcda.svg";
export { ForwardRef as ReactComponent };